var React = require('react');

function IconArrowUp (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1 6L5 2L9 6","stroke":"none","strokeWidth":"1.5"}));
}

IconArrowUp.defaultProps = {"width":"10","height":"7","viewBox":"0 0 10 7","fill":"none"};

module.exports = IconArrowUp;

IconArrowUp.default = IconArrowUp;
